module.exports = __webpack_public_path__ + "media/images/registration-collage-banner-175067200e45f5031c8199c85eeb1373.jpg";